// CSV Utilities for bulk import/export

export const parseCSV = (csvText: string): string[] => {
  // Split by newlines and commas, filter empty
  return csvText
    .split(/[\n,]+/)
    .map(name => name.trim())
    .filter(name => name.length > 0);
};

export const generateAttendanceCSV = (
  students: { name: string; username: string; present: boolean }[],
  date: string
): string => {
  const headers = ['Name', 'Username', 'Status', 'Date'];
  const rows = students.map(s => [
    s.name,
    s.username,
    s.present ? 'Present' : 'Absent',
    date
  ]);
  
  return [headers.join(','), ...rows.map(r => r.join(','))].join('\n');
};

export const downloadCSV = (csvContent: string, filename: string) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
};

export const generateAttendancePDF = (
  students: { name: string; username: string; present: boolean }[],
  date: string
): string => {
  // Simple text-based "PDF" content for demo
  let content = `CHEMSMART ACADEMY - ATTENDANCE REPORT\n`;
  content += `================================\n\n`;
  content += `Date: ${date}\n`;
  content += `Total Students: ${students.length}\n`;
  content += `Present: ${students.filter(s => s.present).length}\n`;
  content += `Absent: ${students.filter(s => !s.present).length}\n\n`;
  content += `--------------------------------\n\n`;
  
  students.forEach((s, i) => {
    content += `${i + 1}. ${s.name} (@${s.username}) - ${s.present ? '✓ PRESENT' : '✗ ABSENT'}\n`;
  });
  
  return content;
};

export const downloadTextAsFile = (content: string, filename: string) => {
  const blob = new Blob([content], { type: 'text/plain;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
};
